// extracted by mini-css-extract-plugin
export default {"metadado":"MedadadosModal_metadado__MbQe1","item":"MedadadosModal_item__OmOvH","valor":"MedadadosModal_valor__sORuf"};